module.exports = __webpack_public_path__ + "static/media/top-arrow.02a0129d.svg";